import { render, staticRenderFns } from "./AddRetailPartner.vue?vue&type=template&id=862df650&"
import script from "./AddRetailPartner.vue?vue&type=script&lang=js&"
export * from "./AddRetailPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports